import React from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as Daily } from "Assets/icons/daily.svg";
import { ReactComponent as Weekly } from "Assets/icons/weekly.svg";
import { ReactComponent as Monthly } from "Assets/icons/monthly.svg";
import ReportIcon from "Assets/Images/report.png";
const Report = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <div className="megaMenuContent">
            <div className="row h-100 align-items-center">
                <div className="col-9">
                    <div className="row">
                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Market/Report/Daily" className="tradesFeeItems py-2 px-3 w-100">
                                <Daily
                                    className="max-width-100 mx-2 d-inline-block"
                                />

                                {t('daily_reports')}
                            </a>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Market/Report/Weekly" className="tradesFeeItems py-2 px-3 w-100">
                                <Weekly
                                    className="max-width-100 mx-2 d-inline-block"
                                />
                                {t('weekly_reports')}
                            </a>
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Market/Report/Monthly" className="tradesFeeItems py-2 px-3 w-100">
                                <Monthly
                                    className="max-width-100 mx-2 d-inline-block"
                                />
                                {t('monthly_reports')}
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-3 d-flex justify-content-center align-items-center">
                    <img
                        src={ReportIcon}
                        width={"100%"}
                        height={"100%"}
                        className="w-100 mx-2 d-block text-blue p-5"
                    />
                </div>

            </div>

        </div>
    );
};

export default Report;
